import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { file_path } from './environment';

function Guides({ guides }) {
    const guideList = Object.entries(guides)
        .sort(([idA], [idB]) => parseInt(idA) - parseInt(idB))
        .map(([id, guide]) => {
            const latestYear = [...guide.years].sort((a, b) => b - a)[0];
            const href = `/research/${guide.guideType}/${latestYear}`;

            return (
                <div key={guide.id}>
                    <h4>
                        <Link to={href}>{guide.guideType}</Link>
                    </h4>
                </div>
            );
        });

    return guideList;
}

export default function ResearchIndex() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get(file_path('/research.json')).then((res) => {
            setGuides(res.data);
        });
    }, []);

    useEffect(() => {
        document.title = 'Research';
    }, []);

    return (
        <div className="container">
            <div className="body1">
                <h2>Research Schedule</h2>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
